"use client"

import { Dispatch, SetStateAction, useRef } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { InputDescription } from "../../../components/InputRow/InputDescription"

interface FileInputProps {
  exportFile: File | null
  setExportFile: Dispatch<SetStateAction<File | null>>
  disabled?: boolean
}

export function FileInput({
  exportFile,
  setExportFile,
  disabled = false,
}: FileInputProps) {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (files && files.length > 0) {
      setExportFile(files[0])
    }
  }

  return (
    <div className="space-y-2">
      <InputDescription>Upload XML file</InputDescription>
      <div className="flex items-center gap-2 max-w-[400px]">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
          className="cursor-pointer"
        >
          Choose File
        </Button>

        <span className="text-sm text-muted-foreground">
          {exportFile ? exportFile.name : "No file chosen"}
        </span>

        <Input
          ref={fileInputRef}
          type="file"
          onChange={handleFileChange}
          disabled={disabled}
          className="hidden"
        />
      </div>
      <p className="text-sm text-muted-foreground">
        {exportFile?.type.includes("zip")
          ? "We'll process your Substack ZIP export to import your posts."
          : "Upload a WordPress export XML file or a Substack ZIP export file."}
      </p>
    </div>
  )
}
